<template>
  <div id="about-us">
    <div class="logo">
      <img src="@/assets/images/common/logo.png" alt="锦鲤保">
    </div>
    <ul>
      <li>
        <span>公司名称</span>
        <p>杭州锦鲤保科技有限公司</p>
      </li>
      <li>
        <span>公司地址</span>
        <p>浙江省杭州市滨江区西兴街道江陵路88号</p>
      </li>
      <li>
        <span>官方微信</span>
        <p>锦鲤好运保</p>
      </li>
      <li>
        <span>公司介绍</span>
        <p>
          <span>我们是一家专业的、面向老百姓的家庭保障规划服务平台，为客户提供保险咨询、方案设计、核保投保以及后续保全、理赔等一条龙服务！</span>
          <span>公司股东和投资方实力雄厚，包括知名投资机构、阿里巴巴合伙人等，已被评为中国保险科技50强公司，InsurStar新锐公司，入选美国PNP保险科技加速营成员单位！</span>
          <span>我们与全国数十家保险公司深度合作，始终以“为客户提供高水平的保险服务”为宗旨，通过顶尖的保险研究团队、服务团队和理赔团队，让用户放心买到最适合自己且性价比最高的保险产品！</span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
// 关于我们
export default {
  name: 'aboutUs',
  created(){
    this.Global.getShareConfig({
      title: '点击获取私人家庭保障方案',
      desc: '一对一咨询，分析风险，定制保障方案，让你买的放心，保的全面'
    },this)
  }
}
</script>

<style scoped>
#about-us ul li p span{
  display: block;
  width: 100%;
  color: #7F7F7F;
  text-indent: 1.9rem
}
  #about-us{
    background: #F6F3F7;
    min-height: 100vh;
  }
  #about-us .logo{
    text-align: center;
    padding: 0.78rem 0 1.41rem;
  }
  #about-us .logo img{
    width: 6.13rem;
  }
  #about-us ul{
    background: #FFF;
    padding: 0 1.4rem;
    font-size: 0.94rem;
    line-height: 1.27rem;
  }
  #about-us ul li{
    padding: 1rem 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d7dae2;
  }
  #about-us ul li:last-child{
    border: none;
  }
  #about-us ul li p{
    flex: 1;
    text-align: justify;
    color: #7F7F7F;
  }
  #about-us ul li span{
    width: 6.5rem;
    color: #403F3F;
  }
</style>